export default __webpack_public_path__ + "static/media/checkboxChecked.7f6c2da0.svg";